function baseProperty(r){return function(e){return null==e?void 0:e[r]}}module.exports=baseProperty;